import React from 'react';
import {
  Row, Col, Typography, Form, Select, Input,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import PropTypes from 'prop-types';
import { getUserType } from '../../../../../utils/users';
import './DetailsFields.scss';

const Details = (props): JSX.Element => {
  const {
    initialValuesObject, edit, listModels, detail,
  } = props;

  const listOrderType = [
    'Interna',
    'Externa',
  ];

  return (
    <>
      <Row
        gutter={[24, 24]}
        className="AssistenciaTecnicaDetails__GridSizeRow"
      >
        <Col
          xs={{ span: 24 }}
          className="AssistenciaTecnicaDetails__GridSizeColumn"
        >
          <Form.Item
            label={(
              <Typography.Title
                level={5}
                className="AssistenciaTecnicaDetails__GridSizeTitle AssistenciaTecnicaDetails__AllFormLabels"
              >
                Qual o município em que se encontra o equipamento?
              </Typography.Title>
            )}
            name="POS_VENDA_ASSISTENCIA_TECNICA_MUNICIPIO"
            className="AssistenciaTecnicaDetails__GridSizeFormItem"
            rules={[]}
            initialValue={initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA_MUNICIPIO']}
          >
            <Input
              style={{ width: '100%' }}
              maxLength={50}
              disabled={edit}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={24}
        className="inline-field"
      >
        <Col span={24}>
          <Form.Item
            name="POS_VENDA_ASSISTENCIA_TECNICA_MODELO"
            rules={[]}
            label={(
              <span
                className="AssistenciaTecnicaDetails__PRNTCalcarioTitle AssistenciaTecnicaDetails__AllFormLabels"
              >
                Modelo do equipamento
              </span>
            )}
            initialValue={initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA_MODELO'] || undefined}
          >
            <Select disabled={edit} className="AssistenciaTecnicaDetails__GridSizeSelect">
              {
                listModels && listModels.map((_item) => (
                  <Select.Option key={_item.id} value={_item.name}>
                    {_item.name}
                  </Select.Option>
                ))
              }
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="AssistenciaTecnicaDetails__GridSizeRow"
      >
        <Col
          xs={{ span: 24 }}
          className="AssistenciaTecnicaDetails__GridSizeColumn"
        >
          <Form.Item
            label={(
              <Typography.Title
                level={5}
                className="AssistenciaTecnicaDetails__GridSizeTitle AssistenciaTecnicaDetails__AllFormLabels"
              >
                Motivo da solicitação
              </Typography.Title>
            )}
            name="POS_VENDA_ASSISTENCIA_TECNICA_MOTIVO_SOLICITACAO"
            className="AssistenciaTecnicaDetails__GridSizeFormItem"
            rules={[
              {
                required: true,
                message: 'O campo é obrigatório',
              },
            ]}
            initialValue={initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA_MOTIVO_SOLICITACAO']}
          >
            <Input.TextArea
              style={{ width: '100%' }}
              maxLength={255}
              disabled={edit}
            />
          </Form.Item>
        </Col>
      </Row>

      {
        edit === true
          && initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA_TIPO_ORDEM']
          && getUserType() === 'COOPERCITRUS'
          ? (
            <Row
              gutter={24}
              className="inline-field"
            >
              <Col span={24}>
                <Form.Item
                  name="POS_VENDA_ASSISTENCIA_TECNICA_TIPO_ORDEM"
                  rules={[
                    {
                      required: true,
                      message: 'O campo é obrigatório',
                    },
                  ]}
                  label={(
                    <span
                      className="AssistenciaTecnicaDetails__PRNTCalcarioTitle AssistenciaTecnicaDetails__AllFormLabels"
                    >
                      Tipo de ordem
                    </span>
                  )}
                  initialValue={initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA_TIPO_ORDEM'] || undefined}
                >
                  <Select disabled={edit} className="AssistenciaTecnicaDetails__GridSizeSelect">
                    {
                      listOrderType.map((_item) => (
                        <Select.Option key={_item} value={_item}>
                          {_item}
                        </Select.Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )
          : edit === undefined
            && getUserType() === 'COOPERCITRUS'
            ? (
              <Row
                gutter={24}
                className="inline-field"
              >
                <Col span={24}>
                  <Form.Item
                    name="POS_VENDA_ASSISTENCIA_TECNICA_TIPO_ORDEM"
                    rules={[
                      {
                        required: true,
                        message: 'O campo é obrigatório',
                      },
                    ]}
                    label={(
                      <span
                        className="AssistenciaTecnicaDetails__PRNTCalcarioTitle AssistenciaTecnicaDetails__AllFormLabels"
                      >
                        Tipo de ordem
                      </span>
                    )}
                    initialValue={initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA_TIPO_ORDEM'] || undefined}
                  >
                    <Select disabled={edit} className="AssistenciaTecnicaDetails__GridSizeSelect">
                      {
                        listOrderType.map((_item) => (
                          <Select.Option key={_item} value={_item}>
                            {_item}
                          </Select.Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )
            : null
      }

      {
        getUserType() === 'COOPERCITRUS' && !detail
        && (
          <>
            <Row gutter={[24, 24]}>
              <Col xs={{ span: 24 }}>
                <hr />
                <p className="AssistenciaTecnicaDetails__SessionTitle">Orçamento</p>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="AssistenciaTecnicaDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="AssistenciaTecnicaDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="AssistenciaTecnicaDetails__GridSizeTitle AssistenciaTecnicaDetails__AllFormLabels"
                    >
                      Valor unitário
                    </Typography.Title>
                  )}
                  name="POS_VENDA_ASSISTENCIA_TECNICA-VALOR_UNITARIO"
                  className="AssistenciaTecnicaDetails__GridSizeFormItem"
                  rules={[
                    {
                      validator: (rule, value): Promise<void | Error> => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA-VALOR_UNITARIO']
                        ? initialValuesObject['POS_VENDA_ASSISTENCIA_TECNICA-VALOR_UNITARIO'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="AssistenciaTecnicaDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="AssistenciaTecnicaDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="AssistenciaTecnicaDetails__GridSizeTitle AssistenciaTecnicaDetails__AllFormLabels"
                    >
                      Valor total
                    </Typography.Title>
                  )}
                  name="POS_VENDA_ASSISTENCIA_TECNICA-VALOR_TOTAL"
                  className="AssistenciaTecnicaDetails__GridSizeFormItem"
                  rules={[
                    {
                      validator: (rule, value): Promise<void | Error> => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA-VALOR_TOTAL']
                        ? initialValuesObject['POS_VENDA_ASSISTENCIA_TECNICA-VALOR_TOTAL'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="AssistenciaTecnicaDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="AssistenciaTecnicaDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="AssistenciaTecnicaDetails__GridSizeTitle AssistenciaTecnicaDetails__AllFormLabels"
                    >
                      Condição de pagamento
                    </Typography.Title>
                  )}
                  name="POS_VENDA_ASSISTENCIA_TECNICA-CONDICAO_PAGAMENTO"
                  className="AssistenciaTecnicaDetails__GridSizeFormItem"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA-CONDICAO_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="AssistenciaTecnicaDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="AssistenciaTecnicaDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="AssistenciaTecnicaDetails__GridSizeTitle AssistenciaTecnicaDetails__AllFormLabels"
                    >
                      Forma de pagamento
                    </Typography.Title>
                  )}
                  name="POS_VENDA_ASSISTENCIA_TECNICA-FORMA_PAGAMENTO"
                  className="AssistenciaTecnicaDetails__GridSizeFormItem"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA-FORMA_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="AssistenciaTecnicaDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="AssistenciaTecnicaDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="AssistenciaTecnicaDetails__GridSizeTitle AssistenciaTecnicaDetails__AllFormLabels"
                    >
                      Observações do orçamento
                    </Typography.Title>
                  )}
                  name="POS_VENDA_ASSISTENCIA_TECNICA-OBSERVACOES"
                  className="AssistenciaTecnicaDetails__GridSizeFormItem"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['POS_VENDA_ASSISTENCIA_TECNICA-OBSERVACOES']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )
      }

    </>
  );
};

Details.propTypes = {
  formInstance: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
    validateFields: PropTypes.func.isRequired,
  }).isRequired,

  mode: PropTypes.oneOf(['CREATE', 'EDIT']).isRequired,
  listModels: PropTypes.objectOf(PropTypes.any).isRequired,

  initialValuesObject: PropTypes.shape({
    POS_VENDA_ASSISTENCIA_TECNICA_MUNICIPIO: PropTypes.string,
    POS_VENDA_ASSISTENCIA_TECNICA_MODELO: PropTypes.string,
    POS_VENDA_ASSISTENCIA_TECNICA_MOTIVO_SOLICITACAO: PropTypes.oneOfType(
      [
        PropTypes.string, PropTypes.number,
      ],
    ),
    POS_VENDA_ASSISTENCIA_TECNICA_TIPO_ORDEM: PropTypes.string,
    'POS_VENDA_ASSISTENCIA_TECNICA-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_ASSISTENCIA_TECNICA-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_ASSISTENCIA_TECNICA-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_ASSISTENCIA_TECNICA-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_ASSISTENCIA_TECNICA-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
  detail: PropTypes.bool,
};
Details.defaultProps = {
  detail: false,
};

export default Details;
